package ru.it_mozaika.sender.js.application.context

import io.ktor.client.call.*
import js.core.jso
import oldcomponents.NotyType
import oldcomponents.showNotification
import react.*
import ru.it_mozaika.sender.common.models.SubscriptionList
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.utils.checkResponseError

external interface SubscriptionListContextInterface {
    var isMultiple: Boolean
    var lists: Set<SubscriptionList>
    var currentIds: Set<String>
    var currentLists: () -> List<SubscriptionList>
    var toggleCurrentId: (String) -> Unit
    var setCurrentIds: (Set<String>) -> Unit
    var clearCurrentIds: () -> Unit
    var addAllLists: () -> Unit
}

val SubscriptionListContext = createContext<SubscriptionListContextInterface>(jso {
    isMultiple = false
    lists = emptySet()
    currentIds = emptySet()
    currentLists = { emptyList() }
    toggleCurrentId = {}
    setCurrentIds = {}
    clearCurrentIds = {}
    addAllLists = {}
})

external interface SubscriptionListProviderProps : PropsWithChildren {
    var multiple: Boolean
}
val SubscriptionListProvider = FC<SubscriptionListProviderProps> { props ->
    val store = useStore().currentStoreId
    var lists by useState(emptySet<SubscriptionList>())
    var currentIds by useState(emptySet<String>())
    useEffect(store) {
        if (store.isNullOrBlank())
            return@useEffect
        Http.get("/subscribers/lists", query = mapOf("store" to store)) { response ->
            response.checkResponseError()?.let {
                showNotification(it, NotyType.Error)
                return@get
            }
            lists = response.body<List<SubscriptionList>>().toSet()
            currentIds = emptySet()
        }
    }
    SubscriptionListContext.Provider {
        value = jso {
            this.isMultiple = props.multiple
            this.lists = lists
            this.currentIds = currentIds
            this.currentLists = {
                lists.filter { currentIds.contains(it.id) }
            }
            this.toggleCurrentId = {
                currentIds = when {
                    !props.multiple -> setOf(it)
                    currentIds.contains(it) -> currentIds.minus(it)
                    else -> currentIds.plus(it)
                }
            }
            this.setCurrentIds = {
                currentIds = it
            }
            this.clearCurrentIds = { currentIds = emptySet() }
            this.addAllLists = { currentIds = lists.map { it.id }.toSet() }
        }
        +props.children
    }
}
fun useSubscriptionLists() = useContext(SubscriptionListContext)